import { render, staticRenderFns } from "./ChooseFileHeader.vue?vue&type=template&id=611065eb&scoped=true&"
import script from "./ChooseFileHeader.vue?vue&type=script&lang=js&"
export * from "./ChooseFileHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChooseFileHeader.vue?vue&type=style&index=0&id=611065eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611065eb",
  null
  
)

export default component.exports